import type { CardApiContract } from '../../../core/api';
import type { CardUiModel } from '../../../core/types';

export function mapCardContractToUiModel(contract: CardApiContract): CardUiModel {
  return {
    id: contract.id,
    projectId: contract.projectId,
    workflowId: contract.workflowId,
    workflowStageId: contract.workflowStageId,
    title: contract.title,
    ownerName: contract.ownerName,
    dueDate: contract.dueDate,
    commentsCount: contract.commentsCount,
    attachmentsCount: contract.attachmentsCount,
    checklistDone: contract.checklistDone,
    checklistTotal: contract.checklistTotal,
    quickFields: contract.quickFields ?? [],
  };
}
